import React from "react";
import { useNavigate } from "react-router-dom";
import { dateFormat } from '../../src/constants/Utils';

export default function SmallCardDashboard(props) {
    const navigate = useNavigate();
    const zoneDetails = () => {
        navigate(props.link, { state: { data: props.data } });
    };

    return (
        <>
            {props.data !== undefined ? (
                <div className="small-card" onClick={zoneDetails}>
                    <div className="small-card-container">
                        <div className="small-card-header mediumFont">
                            <div>{props.header}</div>
                            <div className="small-card-header-left" style={{ fontWeight: 0 }} > {props.data["vc_number"]} </div>
                        </div>
                        <div className="small-card-tabs-container">
                            {props.subheader.map((values) => {
                                return (
                                    <div className="small-card-tabs">
                                        <span className="small-card-tabs-heading smallFont">
                                            {values.name}
                                        </span>
                                        <span className="small-card-tabs-data regularFont">
                                            {
                                                values.name === "Last Updated At" ?
                                                    dateFormat(props.data[values.vars]) :
                                                    props.data[values.vars] ? props.data[values.vars] :
                                                        props.data["area_fk__area_name"] ?
                                                            props.data["area_fk__area_name"] : "-"
                                            }
                                           
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
}
